<template>
    <v-app id="inspire" class="main-view">
        <div class="d-flex justify-center align-center align-self-center page-error">
            <div class="notfound">
                <div class="notfound-404">
                    <div/>
                    <h1>OOP</h1>
                </div>
                <h2 v-html="$t('error.common.title')"/>
                <p v-html="$t('error.common.description')"/>
                <a href="/">{{ $t('Home page') }}</a>
            </div>
        </div>
    </v-app>
</template>

<script>
export default {
  name: 'ErrorCommon'
}
</script>

<style lang="scss" scoped>
.page-error {
    min-height: 100vh;

    .notfound {
        max-width: 600px;
        width: 100%;
        text-align: center;
        line-height: 1.4;
    }

    .notfound .notfound-404 {
        position: relative;
        width: 180px;
        height: 180px;
        margin: 0 auto 50px;
    }

    .notfound .notfound-404>div:first-child {
        position: absolute;
        left: 0;
        right: 0;
        top: 0;
        bottom: 0;
        background: #f54542;
        -webkit-transform: rotate(45deg);
        -ms-transform: rotate(45deg);
        transform: rotate(45deg);
        border: 5px dashed #000;
        border-radius: 5px;
    }

    .notfound .notfound-404>div:first-child:before {
        content: '';
        position: absolute;
        left: -5px;
        right: -5px;
        bottom: -5px;
        top: -5px;
        -webkit-box-shadow: 0 0 0 5px rgba(0,0,0,.1) inset;
        box-shadow: 0 0 0 5px rgba(0,0,0,.1) inset;
        border-radius: 5px;
    }

    .notfound .notfound-404 h1 {
        font-family: cabin,sans-serif;
        font-weight: 700;
        margin: 0;
        font-size: 90px;
        position: absolute;
        top: 50%;
        -webkit-transform: translate(-50%,-50%);
        -ms-transform: translate(-50%,-50%);
        transform: translate(-50%,-50%);
        left: 50%;
        text-align: center;
        height: 40px;
        line-height: 40px;
    }

    .notfound h2 {
        font-family: cabin,sans-serif;
        font-size: 33px;
        font-weight: 700;
        text-transform: uppercase;
        letter-spacing: 7px;
    }

    .notfound p {
        font-family: cabin,sans-serif;
        font-size: 16px;
        font-weight: 400;
    }

    .notfound a {
        font-family: cabin,sans-serif;
        display: inline-block;
        padding: 10px 25px;
        background-color: #4287f5;
        border: none;
        border-radius: 40px;
        color: #fff;
        font-size: 14px;
        font-weight: 700;
        text-transform: uppercase;
        text-decoration: none;
        -webkit-transition: .2s all;
        transition: .2s all;
    }

    .notfound a:hover {
        background-color: #2c2c2c;
    }
}
</style>
